import { SVGProps } from "react"

const LocationBuildings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.97656 5.36458L8.64323 2.03125V15.3646H3.97656V5.36458Z"
      stroke="#2F69FE"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.64062 5.03125L13.3073 8.36458V15.3646"
      stroke="#2F69FE"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.64062 15.3633H14.974"
      stroke="#2F69FE"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.64062 15.3633H14.974"
      stroke="#2F69FE"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default LocationBuildings
